<template>
  <div id="overlay">
    <div class="center w-6/12">
      <div
        class="content border border-1 border-solid bg-white p-2 flex flex-col"
      >
        <div class="text-gray-800 text-3xl my-auto">
          {{ "Add User" }}
        </div>
        <div class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <input
              class="effect-16 w-full"
              type="text"
              placeholder="Username*"
              v-model="username"
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <div class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <input
              class="effect-16 w-full"
              type="text"
              placeholder="Name*"
              v-model="name"
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <div class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <input
              class="effect-16 w-full"
              type="password"
              placeholder="Password*"
              v-model="password"
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <div class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <input
              class="effect-16 w-full"
              type="password"
              placeholder="Confirm Password*"
              v-model="repeatPassword"
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>

        <div class="text-gray-800 text-3xl mt-1">
          <div class="col-3 input-effect w-full">
            <select
              class="effect-16 w-full text-base"
              v-model="selectedType"
              required
            >
              <option value="" selected disabled hidden>User Type*</option>
              <option v-for="(type, index) in types" :key="index" :value="type">
                {{ type }}
              </option>
            </select>
            <span class="focus-border w-full"></span>
          </div>
        </div>

        <div class="w-full flex justify-end p-3 cursor-default">
          <div class="flex flex-row" style="width: 300px">
            <button
              :disabled="
                name.length == 0 ||
                selectedType.length == 0 ||
                username.length == 0 ||
                password != repeatPassword ||
                password.length < 6
              "
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('addUser', username, name, password, selectedType)"
            >
              Add User
            </button>
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    types: Array,
  },

  data() {
    return {
      selectedType: "",
      isOptionsExpanded: false,
      sortFilter: "creationDate",
      options: ["creationDate", "status"],
      username: "",
      name: "",
      password: "",
      repeatPassword: "",
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped>
button {
  transition: all 0.3s;
}

button:hover {
  background-color: gray !important;
}

button:disabled {
  background-color: gray !important;
}

:focus {
  outline: none;
}

.col-3 {
  position: relative;
}

/* necessary to give position: relative to parent. */
input[type="text"],
input[type="password"] {
  font: 15px/24px "Lato", Arial, sans-serif;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}

.effect-16 {
  border: 0;
  padding: 4px 0;
  border-bottom: 1px solid #ccc;
  background-color: transparent;
}

.effect-16 ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3399ff;
  transition: 0.4s;
}

.effect-16:focus ~ .focus-border,
.has-content.effect-16 ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.effect-16 ~ label {
  position: absolute;
  left: 0;
  width: 100%;
  top: 9px;
  color: #aaa;
  transition: 0.3s;
  z-index: -1;
  letter-spacing: 0.5px;
}

.effect-16:focus ~ label,
.has-content.effect-16 ~ label {
  top: -16px;
  font-size: 12px;
  color: #3399ff;
  transition: 0.3s;
}
</style>
